import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL,
  CLEAR_ERROR,
} from "../constants/AuthConstants";

const initialState = {
  authKey: null,
  loading: false,
  isAuthenticated: false,
  msg: null,
  userDetails: null,
};

export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        msg: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        authKey: action.payload.authKey,
        msg: null,
      };

    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        authKey: null,
        msg: action.payload.msg,
      };

    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        authKey: null,
        userDetails: null,
        msg: null,
      };

    case LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
        msg: action.payload.msg,
      };

    case REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        msg: null,
      };

    case REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        msg: action.payload.message,
      };

    case REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        msg: action.payload.msg,
      };

    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: action.payload,
      };

    case FETCH_USER_FAIL:
      return {
        ...state,
        loading: false,
        userDetails: null,
        msg: action.payload.msg,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        msg: null,
      };

    default:
      return state;
  }
};
